var $ = require('jquery');

$(document).ready(function() {
    initGroup();
})
function initGroup() {
    $('.page-section--main > .wp-block-group').each(function() {
        var prev = $(this).prev();

        if(prev.length == 0) {
            $(this).addClass('-banner');
        }
    })
}
